// Instructors who aren't admins are org-library users, not personal-sandbox users (see
// docs/job-module-public-access-backend-plan.md), so every Job Builder API call rejects them.
// Keep them out of the page rather than letting it fail on the first request.
export const canUseJobBuilder = (
  user: { isInstructor?: boolean; isOrganizationAdmin?: boolean } | null | undefined
) => !(user?.isInstructor && !user.isOrganizationAdmin);
